import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';
import Icon from '../Icon';

export const ErrorMessage = ({ id, defaultMessage }: IFormattedMessage) => (
  <div className="d-flex mt-2 mb-2">
    <span className="exclamation-mark mr-2"><Icon icon="exclamation" /></span>
    <div className={styles.errorMessage}><FormattedMessage id={id} defaultMessage={defaultMessage} /></div>
  </div>
);
